/** 密码强度校验 - 作者: zbq, 日期: 2026-06-03 */

export const PASSWORD_RULE_TIP = '密码至少8位，须包含大小写字母、数字及@、_、-';

const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@_-])[A-Za-z\d@_-]{8,}$/;

/** @returns {string} 空字符串表示通过，否则为错误提示 */
export function validatePassword(password) {
  if (!password) return '请设置密码';
  if (!PASSWORD_REGEX.test(password)) return PASSWORD_RULE_TIP;
  return '';
}
